import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-996187be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "component-socket-value__icon"
};
const _hoisted_2 = {
    key: 1,
    class: "socket-controls"
};
import { computed } from "vue";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import ComponentDisplayName from "src/shared/v-components/component/ComponentDisplayName.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GenericComponentSocketValue',
    props: {
        componentId: {},
        size: { default: "medium" },
        settingName: {}
    },
    emits: ["navigateToViewComponent", "confirmDeleteInstalledComponent"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "433511ba": (componentSocketValueBorderColor.value)
        }));
        const props = __props;
        const emit = __emit;
        const { builtComponent: builtComponentRef } = useBuiltComponent(props.componentId);
        const builtComponent = computed(() => builtComponentRef.value);
        const componentSocketValueBorderColor = computed(() => {
            var _a;
            return ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getColor()) || "#969dab";
        });
        const componentSocketValueIcon = computed(() => {
            var _a;
            return ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getIcon()) || undefined;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["component-socket-value", [`component-socket-value--${_ctx.size}`]]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (emit('navigateToViewComponent', _ctx.componentId)), ["stop"]))
            }, [
                (componentSocketValueIcon.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("i", {
                            class: _normalizeClass(componentSocketValueIcon.value)
                        }, null, 2 /* CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(ComponentDisplayName, {
                    "tag-name": 'h3',
                    componentId: _ctx.componentId
                }, null, 8 /* PROPS */, ["componentId"]),
                (_ctx.size === 'medium')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("i", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('confirmDeleteInstalledComponent')), ["stop"])),
                            class: "fal fa-trash"
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
